"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = isPromise;
function isPromise(promise) {
    return !!promise &&
        (typeof promise === 'object' || typeof promise === 'function') &&
        typeof promise.then === 'function';
}
